import React, { ReactElement, useMemo } from 'react';
import { Tooltip } from '@economic/taco';
import { DimensionData } from '~/types/internal-api';

import { Dimension, DimensionsAccess } from '../types';
import useDimensionsAccessLevel from '../hooks/useDimensionsAccessLevel';
import parseData, { getListOfDimensionValuesNames } from './SelectedDimensions.formatters';
import { SelectedDimensionsProps } from './SelectedDimensions.types';

function SelectedDimensions(props: {
    data: DimensionData[];
    allDimensions: Dimension[];
    isLoading: boolean;
    hideTooltip?: boolean;
}): ReactElement;
function SelectedDimensions(props: {
    data: (number | undefined)[];
    allDimensions: Dimension[];
    isLoading: boolean;
    hideTooltip?: boolean;
}): ReactElement;
function SelectedDimensions({ data, allDimensions, isLoading, hideTooltip = false }: SelectedDimensionsProps): ReactElement {
    const hasMultiDimensions = useDimensionsAccessLevel(DimensionsAccess.HasMultiDimensions);

    const ids = useMemo(() => {
        const parsedData = parseData(data, allDimensions);
        if (!hasMultiDimensions) {
            parsedData.splice(1, 2);
        }

        return parsedData;
    }, [data, allDimensions, hasMultiDimensions]);

    if (isLoading) {
        return <span>...</span>;
    }

    const listOfNames = getListOfDimensionValuesNames(ids, allDimensions);

    const listOfIds = ids.map(dim => dim ?? '').join(', ');

    if (hideTooltip) {
        return <span>{listOfIds}</span>;
    }

    return (
        <Tooltip title={listOfNames}>
            <span>{listOfIds}</span>
        </Tooltip>
    );
}

export default SelectedDimensions;
